import { Component } from '@angular/core';

import { RelatedCardFacade } from '@ridango/components';

import { Observable } from 'rxjs';

@Component({
    selector: 'rwidget-related-card-add-and-edit-aside',
    templateUrl: './related-card-add-and-edit-aside.component.html',
    styleUrls: ['./related-card-add-and-edit-aside.component.scss']
})
export class RelatedCardAddAndEditAsideComponent {
    editMode$: Observable<boolean> = this.relatedCardFacade.editMode$;

    constructor(private relatedCardFacade: RelatedCardFacade) {}
}
